// extracted by mini-css-extract-plugin
module.exports = {"app":"Main_app__2TkeV","content":"Main_content__12X_t","header":"Main_header__EfdLG"};